import { admin_reviewAPI } from '@/common/service/ApiList';
import ServiceExec from '@/common/utils/ServiceExec';

export default {
  async fetchAdminReviewList({ commit, state }, payload) {
    const { page, totalPage, limit } = state;
    if (page > totalPage) return;

    const { status, data } = await ServiceExec.get(
      admin_reviewAPI.review_list,
      {
        page,
        limit,
        ...payload
      }
    );
    const { pageInfo, list } = data;
    commit('setPageInfo', pageInfo);
    commit('setPage', page + 1);
    commit('setTotalPage', pageInfo?.totalPage ?? 2);
    commit('setAdminReviewList', list ?? []);
  },

  async initAdminReviewList({ commit, state }, payload) {
    commit('initList');
    const { page, totalPage, limit } = state;
    if (page > totalPage) return;

    const { status, data } = await ServiceExec.get(
      admin_reviewAPI.review_list,
      { page, limit, ...payload }
    );
    const { pageInfo, list } = data;
    commit('setPageInfo', pageInfo);
    commit('setPage', page + 1);
    commit('setTotalPage', pageInfo?.totalPage ?? 2);
    commit('setAdminReviewList', list ?? []);
  },

  async getAdminReviewList({ commit, state }, payload) {
    const { page, totalPage, limit } = state;
    const { status, data } = await ServiceExec.get(
      admin_reviewAPI.review_list,
      payload
    );
    const { pageInfo, list } = data;
    commit('setPage', page + 1);
    commit('setTotalPage', pageInfo?.totalPage ?? 2);
    commit('setAdminReviewList', list ?? []);
  },

  async updateIsPinned({ commit }, payload) {
    const { storeNo, reviewNo, state } = payload;
    const { status, data } = await ServiceExec.patch(
      admin_reviewAPI.review_update_pin(storeNo, reviewNo, state)
    );

    return data;
  },

  async getDetail({ getters, commit, state }, review) {
    commit('setDetail', review);
  },

  async report({ commit }, payload) {
    const { status, data } = await ServiceExec.post(
      admin_reviewAPI.report,
      payload
    );

    return data;
  },

  async saveReply({ commit }, payload) {
    const { status, data } = await ServiceExec.post(
      admin_reviewAPI.reply_save,
      payload
    );

    return data;
  }
};
